import { getDesignerDefaultStyles, getDesignerDynamicTypes } from "../../designer-advanced-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const advancedTools: ToolHandlerGroup = {
  sync: {
    ui_style_get_default_styles: (input) => getDesignerDefaultStyles(getSdInstance(), input)
  },
  async: {
    ui_structure_get_dynamic_types: async () => getDesignerDynamicTypes(getSdInstance())
  }
};
